(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('MarketPriceDetailController', MarketPriceDetailController);

    MarketPriceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MarketPrice', 'MarketPriceCustomService'];

    function MarketPriceDetailController($scope, $rootScope, $stateParams, previousState, entity, MarketPrice, MarketPriceCustomService) {
        var vm = this;

        vm.marketPrice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:marketPriceUpdate', function(event, result) {
            vm.marketPrice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
